<template>
	<div class="ExpertDatabaseWarp">
		<div class="tabbarBox">
			<div class="TabBox">
				<div v-for="(item,index) in TabsData" :key="index" :class="activeName==item.name?'activcourseItem':'courseItem'" @click="changeTabs(item)">
					{{item.name}}
				</div>

			</div>
			<div class="search-box">
				<el-input type="text" v-model="searchVal" placeholder="请输入新闻标题" @keydown.enter.native="serchEnterFn" clearable>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</div>
		</div>

		<div class="tableBox">
			<div v-if="activeName=='信息创建'">
				<AddSpecialist :currentId="currentId" :tagName='tagName' @modifySuccess="handleModifySuccess" />
			</div>
			<div v-if="activeName=='已发布'">
				<Published :searchVal='searchVal' @changeTab=changeTab />
			</div>
			<div v-if="activeName=='草稿'">
				<Draft :searchVal='searchVal' @changeTab=changeTab />
			</div>
			<div v-if="activeName=='被驳回'">
				<Rejected :searchVal='searchVal' @changeTab=changeTab />
			</div>
			<div v-if="activeName=='待审核'">
				<ToAudit :searchVal='searchVal' @changeTab=changeTab />
			</div>
		</div>

	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import Published from './Published'
import Draft from './Draft'
import Rejected from './Rejected'
import ToAudit from './ToAudit'
import AddSpecialist from './AddSpecialist'
export default {
	components: {
		AddSpecialist,
		Published,
		Draft,
		Rejected,
		ToAudit
	},
	data() {
		return {
			TabsData: [
				{ name: '信息创建' },
				{ name: '已发布' },
				{ name: '待审核' },
				{ name: '被驳回' },
				{ name: '草稿' },
			],
			activeName: '信息创建',
			searchVal: '',
			searchText: '',
			currentId: '',
			tagName: '',

		}
	},
	mounted() {
		this.activeName = this.$route.query.activeName || '信息创建'
	},
	methods: {
		serchEnterFn(e) {
			// let keyCode = window.event ? e.keyCode : e.which;
			// if (keyCode == 13) {
			// 	this.searchFn();
			// }
		},
		changeTabs(item) {
			this.activeName = item.name
			this.searchVal = ''
		},
		// 子传父
		changeTab(item, id = null, tag) {
			this.activeName = item.name; // 切换到目标 Tab
			this.currentId = id; // 保存当前选中的 ID
			this.tagName = tag.tagName
		},
		handleModifySuccess(name) {
			this.activeName = name
			this.currentId = ''
			this.tagName = ''
		},


	}
}
</script>
<style lang="less" scoped>
.ExpertDatabaseWarp {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 50px 0 20px;
  .topBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 16px;
    .activcourseItem {
      width: 143px;
      height: 42px;
      line-height: 42px;
      background: #ffb02c;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
    // 搜索框
    .search-box {
      // background: #1088fe;
      width: 256px;
      justify-content: center;
      align-items: center;
      align-content: center;
      text-align: center;
      // padding: 30px 0px;
      display: flex;
      flex-direction: row;
      margin-left: 32px;
      /deep/.el-input__inner {
        // background-color: #68b4ff;
        border: 1px solid rgba(56, 67, 100, 0.2);
        color: #000 !important;
        border-radius: 27px;
        padding-left: 55px;
      }
      /deep/input::placeholder {
        color: #cfd0d6 !important;
      }
      .el-icon-search {
        font-size: 21px;
        padding: 0 0px 0 18px;
        cursor: pointer;
        color: #384364;
      }
    }
  }
  .tabbarBox {
    // display: flex;
    // flex-direction: row;
    position: relative;
    // 搜索框
    .search-box {
      // background: #1088fe;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 256px;
      justify-content: center;
      align-items: center;
      align-content: center;
      text-align: center;
      // padding: 30px 0px;
      display: flex;
      flex-direction: row;
      margin-left: 32px;
      /deep/.el-input__inner {
        // background-color: #68b4ff;
        border: 1px solid rgba(56, 67, 100, 0.2);
        color: #000 !important;
        border-radius: 27px;
        padding-left: 55px;
      }
      /deep/input::placeholder {
        color: #cfd0d6 !important;
      }
      .el-icon-search {
        font-size: 21px;
        padding: 0 0px 0 18px;
        cursor: pointer;
        color: #384364;
      }
    }
  }
  .TabBox {
    display: flex;
    flex-direction: row;
    font-size: 16px;
    padding: 0 0 5px 0px;
    border-bottom: 1px solid #0083ff;
    margin-top: 23px;
    .activcourseItem {
      width: 124px;
      height: 42px;
      line-height: 42px;
      background: #349cff;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      margin-right: 40px;
      cursor: pointer;
    }
    .courseItem {
      width: 124px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      color: #43424b;
      margin-right: 40px;
      cursor: pointer;
    }
  }
}
</style>


